export default __webpack_public_path__ + "static/media/avatar-placeholder.ac8f0ee8.jpg";